module.exports = __webpack_public_path__ + "img/m_2.86990b14.png";